import { connect } from 'react-redux';
import Content from './content.component';
import { ReactNode } from 'react';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State) => ({
    showGameLogo: state.config.friendsReferral?.showGameLogo ?? false
});

export type IContentProps = {
    readonly showGameLogo?: boolean,
    readonly children: ReactNode
};

export default connect(mapStateToProps, null)(Content);
